import React, { useState, useEffect, useRef,useImperativeHandle, forwardRef } from "react";
import PropTypes from "prop-types";
import { Button } from "../../../Button/Button";
import { useCallback } from "react";
import { debounce } from "lodash";
import axios from "axios";
import { setQueryParam, getQueryParam, deleteQueryParam } from "../../Utils/utils";

export const InputSuggestion = forwardRef((props, ref) => {
    const { hasButton,
        isFullWidth,
        hasIcon,
        label,
        isSearch,
        hasLocation,
        className = null,
        passInputValue,
        } = props
    const [inputValue, setInputValue] = useState("");
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [suggestions, setSuggestions] = useState([]);

    const dropdownRef = useRef()

    useEffect(() => {
        const locationParam = getQueryParam("location");
        const lat = getQueryParam("lat");
        const lng = getQueryParam("lng");

        if(locationParam){
            setInputValue(locationParam)
            passInputValue({
                location: {
                    "lat": lat,
                    "long": lng,
                },
                zoom: 12
            })
        }
    }, [])

    useEffect(() => {
        const checkIfClickedOutside = e => {
          if (
            showSuggestions &&
            dropdownRef.current &&
            !dropdownRef.current.contains(e.target)
          ) {
            setShowSuggestions(false)
          }
          else{
            if(inputValue.length >= 3 && dropdownRef.current.contains(e.target))
                setShowSuggestions(true)
          }
        }
        document.addEventListener("mousedown", checkIfClickedOutside)
        
        return () => {
          document.removeEventListener("mousedown", checkIfClickedOutside)
        }
    }, [showSuggestions])

    useEffect(() => {
        async function fetch(){
            if(inputValue.length >= 2 ){
                await loadData(inputValue)
            }
        }
        fetch();
    }, [inputValue])

    useEffect(() => {
        if(suggestions.length > 0){
            setShowSuggestions(true)
        }
        else{
            setShowSuggestions(false)
        }
    }, [suggestions])
    
    const loadData = useCallback(debounce(async (cityName) => {
        setSuggestions([])
        axios.get(`/umbraco/api/community/fetchCommunities?searchTerm=${cityName}`)
        .then(response => {
            setSuggestions(response.data);
        })

    }, 500), []);

    const handleInputChange = async (e) => {
        if(e.target.value == ""){
            deleteQueryParam("location");
        }
        setInputValue(e.target.value)
    }

    const handleClear = () => {
        updateQueryParam("delete");

        setInputValue("")
        setSuggestions([]);
        setShowSuggestions(false)
    }

    const suggestionSelectionHandler = suggestion => {

        setQueryParam("location", suggestion.cityNameNl)

        setInputValue(suggestion.cityNameNl)
        setShowSuggestions(false)
        setSuggestions([]);
        passInputValue({
            location: suggestion,
            zoom: 12
        })
    }

    const handleLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position){
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                setInputValue("Jouw locatie");
                const myLocation = {
                    lat:String(latitude), 
                    long:String(longitude)
                }
                passInputValue({
                    location: myLocation,
                    zoom:12
                })
            }) ;
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }

    const resetFilter = () => {
        deleteQueryParam("location");

        setInputValue("");
        setShowSuggestions(false);
        passInputValue({
            location: {
                lat: "51.037861",
                long: "4.240528"
            },
            zoom: 9
        })
    }

    useImperativeHandle(ref, () => ({
        resetFilter,
    }));

    return (
        <div
            ref={dropdownRef}
            className={`c-input ${hasButton ? 'c-input--has-button' : ''} ${isFullWidth ? 'c-input--full-width' : ''} ${className && className}`}            >
            <input 
                placeholder={label} 
                id="input" 
                className="c-input__field" 
                onChange={e => handleInputChange(e)}
                value={inputValue}
                autoComplete="off"    
            >        
            </input>
            {label && <label htmlFor="input" className="c-input__label">{label}</label>}
            <div className="c-input__right">
                {(isSearch || hasLocation && inputValue !== '') && (
                    <i onClick={handleClear} className="c-input__right__close fal fa-times-circle"></i>
                )}
                {(hasButton) && (
                    <Button buttonType='primary' size='small' hasIcon={true} iconInFront={true} label='zoeken' isIcon={false} icon={props.buttonIcon && props.buttonIcon}></Button>
                )}
                {(isSearch && !hasButton && !inputValue) && (
                    <i className="fal fa-search"></i>
                )}
                {(!isSearch && !hasButton && hasIcon && !hasLocation) && (
                    <i className="fal fa-calendar-alt c-input__icon"></i>
                )}
                {(!isSearch && !hasButton && hasIcon && hasLocation && !inputValue ) &&
                    <div onClick={handleLocation} class="c-input-icon__container">
                        <i class="fa-solid fa-location-crosshairs c-input__icon"></i>
                    </div>
                }
            </div>

            {showSuggestions ? (
                <div className="c-input-suggestion__container">
                    <ul className="c-input-suggestion__ul">
                        {suggestions.map( suggestion => {
                            return(
                                <li 
                                    className="c-input-suggestion__li"
                                    key={suggestion.postalCode} 
                                    onClick={() => suggestionSelectionHandler(suggestion)}
                                >
                                    {suggestion.postalCode}{" "}{suggestion.cityNameNl}
                                </li>
                            )
                        })}
                    </ul>
                </div>
            ):
            (
                <span></span>
            )
            }
            </div>
    );
});

InputSuggestion.propTypes = {
  /**
   * does the input have a button?
   */
  hasButton: PropTypes.bool.isRequired,
  /**
   * is the input a search input?
   */
  isSearch: PropTypes.bool.isRequired,
  /**
   * does the input have an icon?
   */
  hasIcon: PropTypes.bool.isRequired,
  /**
   * does the input have full width?
   */
  isFullWidth: PropTypes.bool.isRequired,
  /**
   * label for the input?
   */
  label: PropTypes.string.isRequired,
};

InputSuggestion.defaultProps = {
  hasButton: false,
  isSearch: false,
  hasIcon: true,
  isFullWidth: false,
  label: 'Zoek een sport of plaats',
};
